import { ProvisionEventEquipment, ProvisionLiner, ProvisionSensor, ProvisionType } from "../../models/provision-models"
import { SelectedElement } from "../../provisions-utils/provision-types"

/**
 * Normalize a list of elements to a distinct list. Preceding elements will overridden by following elements.
 * @param prioritizedList List of elements that are in priority order. First element is least significant.
 * @returns
 */
export function normaliseEquipmentList(prioritizedList: SelectedElement[]) {
    var keyed = prioritizedList.reduce((acc: Record<string, SelectedElement>, eq: SelectedElement) => {
        acc[`${eq.linerSvgReference}${eq.sensorSvgReference}`] = eq
        return acc
    }, {})
    return Object.values(keyed)
}

function mapLinerToEquipment(liner: ProvisionLiner, provisionType: ProvisionType, provisionDate: Date): SelectedElement {
    return {
        equipmentId: liner.id,
        linerSvgReference: liner.linerLocation.reference,
        type: "Liner",
        equipmentOptionId: liner.materialId,
        provisionType,
        provisionDate,
    }
}

function mapSensorToEquipment(sensor: ProvisionSensor, provisionType: ProvisionType, provisionDate: Date): SelectedElement {
    return {
        equipmentId: sensor.id,
        sensorSvgReference: sensor.reference,
        linerSvgReference: sensor.linerReference,
        equipmentOptionId: sensor.serialNumber,
        type: "Sensor",
        provisionType,
        provisionDate,
    }
}

/**
 * Resolve equipment elements from a provision event.
 * @param event Provision event.
 * @returns List of equipment elements.
 */
export function resolveEquipmentElements(event: ProvisionEventEquipment): SelectedElement[] {
    const liners = [...event.liners.map(l => mapLinerToEquipment(l, event.type, event.eventDate))]
    const sensors = [...event.sensors.map(s => mapSensorToEquipment(s, event.type, event.eventDate))]
    return [...liners, ...sensors]
}

/**
 * Sort provision events by event date.
 * @param provisionEventsDetail provision events to sort
 * @returns
 */
export function sortProvisionEvents(provisionEventsDetail: ProvisionEventEquipment[]) {
    return [...provisionEventsDetail].sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime())
}
